const FLAG_REQUEST_INJECTION_SCRIPT_ID = 'flag-request-injection-script-id';

export function attachRequestInjectionScript(): unknown | undefined {
  try {
    if (document.getElementById(FLAG_REQUEST_INJECTION_SCRIPT_ID)) {
      return;
    }

    const parent = document.head || document.documentElement;

    const script = document.createElement('script');
    script.src = chrome.runtime.getURL('request-injection-script.js');
    script.onload = function () {
      // @ts-ignore
      this.remove();
    };
    parent.appendChild(script);

    // create a flag that this document already injected
    const flagElement = document.createElement('script');
    flagElement.id = FLAG_REQUEST_INJECTION_SCRIPT_ID;
    parent.appendChild(flagElement);
  } catch (ex) {
    return ex;
  }
}
